<template>
  <td class="whitespace-nowrap py-3.5 pl-6 pr-3 text-sm font-medium text-gray-900">
    <ul class="space-y-2">
      <li
        v-for="rentalListingAgreementLandlord in rentalListingAgreement.relationships.rentalListingAgreementLandlords.data"
        :key="rentalListingAgreementLandlord.id"
      >
        <CustomerLink :customer="rentalListingAgreementLandlord" @click.stop />
      </li>
    </ul>
  </td>

  <td class="whitespace-nowrap px-3 py-3.5 text-sm text-gray-500">
    <ul class="space-y-2">
      <li
        v-for="rentalListingAgreementProperty in rentalListingAgreement.relationships.rentalListingAgreementProperties.data"
        :key="rentalListingAgreementProperty.id"
      >
        {{ rentalListingAgreementProperty.relationships.property.data.attributes.fullAddress }}
      </li>
    </ul>
  </td>

  <td class="whitespace-nowrap px-3 py-3.5 text-sm text-gray-500">
    {{ rentalListingAgreement.attributes.commission }} {{ commissionTypeSymbol(rentalListingAgreement.relationships.commissionType.data?.attributes?.name) }}
  </td>

  <td class="whitespace-nowrap px-3 py-3.5 text-sm text-gray-500">
    {{ parseDate(rentalListingAgreement.attributes.endAt) }}
  </td>

  <td class="whitespace-nowrap px-3 py-3.5 text-sm">
    <span
      :class="rentalListingAgreement.attributes.transactionStatus === 'completed'
        ? 'bg-green-50 text-green-700 ring-green-600/20'
        : 'bg-gray-50 text-gray-600 ring-gray-500/10'"
      class="inline-flex items-center rounded-md px-2 py-1 text-xs font-medium ring-1 ring-inset"
    >
      {{ rentalListingAgreement.attributes.transactionStatus === 'completed' ? $gettext('Complété') : $gettext('En cours') }}
    </span>
  </td>

  <td class="whitespace-nowrap px-3 py-3.5 text-sm">
    <span
      v-if="rentalListingAgreement.attributes.riskLevel"
      :class="riskLevelClasses[rentalListingAgreement.attributes.riskLevel]"
      class="inline-flex items-center rounded-md px-2 py-1 text-xs font-medium ring-1 ring-inset"
    >
      {{ riskLevelLabels[rentalListingAgreement.attributes.riskLevel] }}
    </span>
    <span v-else class="text-gray-400 text-xs">{{ $gettext('N/A') }}</span>
  </td>

  <td class="relative whitespace-nowrap py-3.5 pl-3 pr-6 text-right text-sm font-medium">
    <div class="flex justify-end gap-2">
      <router-link
        class="rounded-md p-1.5 text-gray-400 hover:text-indigo-600 hover:bg-indigo-50 transition-colors"
        :to="{ name: 'rental-listing-agreement', params: { id: rentalListingAgreement.id } }"
        @click.stop
      >
        <MagnifyingGlassIcon class="size-4" aria-hidden="true" />
      </router-link>
      <router-link
        class="rounded-md p-1.5 text-gray-400 hover:text-indigo-600 hover:bg-indigo-50 transition-colors"
        :to="{ name: 'edit-rental-listing-agreement', params: { id: rentalListingAgreement.id } }"
        @click.stop
      >
        <PencilSquareIcon class="size-4" aria-hidden="true" />
      </router-link>
    </div>
  </td>
</template>

<script setup>
import CustomerLink from "@/components/customers/CustomerLink.vue";
import { PencilSquareIcon, MagnifyingGlassIcon } from "@heroicons/vue/24/outline";
import { useGettext } from "vue3-gettext";
import { useDate } from "@/utils/stores/date";
import { commissionTypeSymbol } from "@/utils/commissionType";

const { $gettext } = useGettext();
const { parseDate } = useDate();

const riskLevelClasses = {
  low: "bg-green-50 text-green-700 ring-green-600/20",
  medium: "bg-amber-50 text-amber-700 ring-amber-600/20",
  high: "bg-red-50 text-red-700 ring-red-600/20",
};

const riskLevelLabels = {
  low: $gettext("Faible"),
  medium: $gettext("Moyen"),
  high: $gettext("Élevé"),
};

const props = defineProps({
  rentalListingAgreement: Object,
});

const rentalListingAgreement = props.rentalListingAgreement;
</script>
